
export function getToday(): string {
  return new Date()
    .toISOString()
    .split('T')[0];
}

export function toFormatDate(
  date: Date
): string {

  return date
    .toISOString()
    .split('T')[0];

}

export function parseLocalDate(
  value: string
): Date {
  const [year, month, day] =
    value.split('-').map(Number);
  return new Date(
    year,
    month - 1,
    day
  );
}